var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 1200,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 1200,
    fill: "#EAEAEA",
    rx: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M600.709 736.5c-75.454 0-136.621-61.167-136.621-136.62 0-75.454 61.167-136.621 136.621-136.621 75.453 0 136.62 61.167 136.62 136.621 0 75.453-61.167 136.62-136.62 136.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9C9C9",
    strokeWidth: 2.418,
    d: "M600.709 736.5c-75.454 0-136.621-61.167-136.621-136.62 0-75.454 61.167-136.621 136.621-136.621 75.453 0 136.62 61.167 136.62 136.621 0 75.453-61.167 136.62-136.62 136.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#a)",
    strokeWidth: 2.418,
    d: "M0-1.209h553.581",
    transform: "scale(1 -1) rotate(45 1163.11 91.165)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#b)",
    strokeWidth: 2.418,
    d: "M404.846 598.671h391.726"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#c)",
    strokeWidth: 2.418,
    d: "M599.5 795.742V404.017"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#d)",
    strokeWidth: 2.418,
    d: "m795.717 796.597-391.441-391.44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M600.709 656.704c-31.384 0-56.825-25.441-56.825-56.824 0-31.384 25.441-56.825 56.825-56.825 31.383 0 56.824 25.441 56.824 56.825 0 31.383-25.441 56.824-56.824 56.824Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M616.426 586.58h-31.434v16.176l3.553-3.554.531-.531h9.068l.074-.074 8.463-8.463h2.565l7.18 7.181V586.58Zm-15.715 14.654 3.698 3.699 1.283 1.282-2.565 2.565-1.282-1.283-5.2-5.199h-6.066l-5.514 5.514-.073.073v2.876a2.418 2.418 0 0 0 2.418 2.418h26.598a2.418 2.418 0 0 0 2.418-2.418v-8.317l-8.463-8.463-7.181 7.181-.071.072Zm-19.347 5.442v4.085a6.045 6.045 0 0 0 6.046 6.045h26.598a6.044 6.044 0 0 0 6.045-6.045v-7.108l1.356-1.355-1.282-1.283-.074-.073v-17.989h-38.689v23.43l-.146.146.146.147Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9C9C9",
    strokeWidth: 2.418,
    d: "M600.709 656.704c-31.384 0-56.825-25.441-56.825-56.824 0-31.384 25.441-56.825 56.825-56.825 31.383 0 56.824 25.441 56.824 56.825 0 31.383-25.441 56.824-56.824 56.824Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 554.061,
    x2: -0.48,
    y1: 0.083,
    y2: 0.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 796.912,
    x2: 404.507,
    y1: 599.963,
    y2: 599.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 600.792,
    x2: 600.794,
    y1: 403.677,
    y2: 796.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 404.85,
    x2: 796.972,
    y1: 403.903,
    y2: 796.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M581.364 580.535h38.689v38.689h-38.689z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.980c1a612fabf875cfd14ad73802ea79.svg";
export { ForwardRef as ReactComponent };